import request from '@/utils/request'

// 账号配置-打卡列表
export function clockList(params = {}) {
  return request({
    url: '/spWorkWechat/spCheckinOption/index',
    method: 'get',
    params
  })
}

// 账号配置-拉取配置企业列表
export function pullConfigList(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/list',
    method: 'get',
    params
  })
}

// 账号配置-拉取配置
export function pullConfig(params = {}) {
  return request({
    url: '/spWorkWechat/spCheckinOption/fetch',
    method: 'get',
    params
  })
}

// 创建打卡规则
export function createRules(data) {
  return request({
    url: '/spWorkWechat/spCheckinOption/create',
    method: 'post',
    data
  })
}

// 周报日报列表
export function reportList(params) {
  return request({
    url: '/spWorkWechat/spReport/index',
    method: 'get',
    params
  })
}

// 创建汇报规则
export function createReportRules(data) {
  return request({
    url: '/spWorkWechat/spReport/create',
    method: 'post',
    data
  })
}

// 更新汇报规则
export function updateReportRules(data) {
  return request({
    url: '/spWorkWechat/spReport/update',
    method: 'post',
    data
  })
}

// 绑定主体列表
export function boundList(params) {
  return request({
    url: '/spWorkWechat/spReportBind/index',
    method: 'get',
    params
  })
}

// 绑定主体创建
export function boundCreate(data) {
  return request({
    url: '/spWorkWechat/spReportBind/create',
    method: 'post',
    data
  })
}

// 绑定主体更新
export function boundUpdate(data) {
  return request({
    url: '/spWorkWechat/spReportBind/update',
    method: 'post',
    data
  })
}
// 部门列表
export function spReportdepartmentList(params) {
  return request({
    url: '/spWorkWechat/spReport/departmentList',
    method: 'get',
    params
  })
}
// 删除绑定信息
export function spReportBinddestroy(data) {
  return request({
    url: '/spWorkWechat/spReportBind/destroy',
    method: 'post',
    data
  })
}
